<template>
  <div
    class="Receipts-Viewer--modal"
    @click="emitResourceId"
  >
    <template v-if="downloading">
      <div class="image-fetching text-center w-100 h-100">
        <spinner></spinner>
      </div>
    </template>
    <template v-else>
      <template v-if="!useEmbed">
        <img
          class="img-content img-thumbnail mx-auto w-100 h-100 image"
          :src="imgResource"
          :alt="imageAlt"
          v-if="imgResource  && resourceData.mimeType !== 'application/pdf'"
        >
        <img
          class="img-content img-thumbnail mx-auto w-100 h-100 image"
          :src="imgResource"
          :alt="imageAlt"
          v-else
        >

        <!-- <pdf
          :class="pdfClass"
          :src="imgResource"
          v-else
        ></pdf> -->
      </template>
      <template v-else>
        <pdf
          v-show="progress === 1"
          @num-pages="pdfNumPages = $event"
          @progress="progress = $event"
          @loaded="showLinks"
          :page="currentPage"
          :src="imgResource"
        ></pdf>
        <div
          class=" d-flex justify-content-center align-items-center w-100 h-100"
          v-if="progress < 1"
        >
          <spinner></spinner>
        </div>
      </template>
      <div
        class="control-buttons mt-2 mb-4 text-center justify-content-center"
        v-show="showControls && progress === 1"
      >
        <button
          class="Fuell-Button blue"
          @click.prevent="downloadFile"
        >{{ $t(downloadLink)}}</button>
        <button
          class="Fuell-Button red ml-2"
          v-if="!hideDelete"
          @click.prevent="deleteFile"
        >{{ $t(deleteLink)}}</button>
      </div>
    </template>
  </div>
</template>

<script>
import { getResourceFromAws } from '@/shared/_api'
import _mediaResourceHandlerMixin from '@/components/Commons/_mixins/_mediaResourceHandlerMixin'
import Spinner from '@/components/Commons/Spinner'
import pdf from 'vue-pdf'
export default {
  name: 'MediaResourceViewer',
  components: { Spinner, pdf },
  mixins: [_mediaResourceHandlerMixin],
  props: {
    file: {
      default: null
    },
    resourceData: {
      type: Object
    },
    imageAlt: {
      type: String
    },
    resourceIndex: { type: Number },
    resourceId: { default: false },
    showResourceLink: {
      type: Boolean,
      default: true
    },
    hideDelete: {
      type: [Boolean, String],
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    useEmbed: {
      type: Boolean,
      default: false
    },
    pdfClass: {
      type: String,
      default: 'img-content img-thumbnail mx-auto'
    }
  },
  data () {
    return {
      fetchedResource: null,
      fetchedResourceLink: null,
      resourceType: null,
      downloading: false,
      downloadingFile: false,
      pdfNumPages: undefined,
      showControls: false,
      currentPage: 1,
      progress: 0
    }
  },
  computed: {
    imgResource () {
      if (this.resourceType === 'application/pdf') {
        return require('@/assets/img/pdf.png')
      }
      return this.fetchedResource
    },
    downloadLink () {
      return this.downloadingFile ? 'media_viewer_fetching_resource' : 'media_viewer_fetch_resource'
    },
    deleteLink () {
      return this.deleting ? 'media_viewer_deleting_resource' : 'media_viewer_delete_resource'
    }
  },
  methods: {
    async downloadFile () {
      if (this.downloadingFile) return
      this.downloadingFile = true
      try {
        const fetchedResource = await getResourceFromAws(this.resourceId)
        this.fetchedResourceLink = document.createElement('a')
        this.fetchedResourceLink.href = URL.createObjectURL(fetchedResource.data)
        const resourceUrl = new URL(encodeURI(fetchedResource.request.responseURL))
        const resourceParams = resourceUrl.searchParams.get('response-content-disposition')
        const resourceName = resourceParams.substring(resourceParams.indexOf('filename') + 11, resourceParams.length)
        this.fetchedResourceLink.download = resourceName || 'resource-' + this.resourceId
        this.$emit('resourceDownloaded', this.resourceId)
      } catch (error) {
        console.error('Download File error', error)
      } finally {
        this.downloadingFile = false
        this.fetchedResourceLink.click()
      }
    },
    async deleteFile () {
      if (this.deleting) return

      this.$emit('handleDelete', this.resourceId)
    },
    emitResourceId () {
      if (this.resourceId) {
        this.$emit('emitResourceId', this.resourceId)
      } else {
        this.$emit('emitResourceId', this.resourceIndex)
      }
    },
    showLinks () {
      this.showControls = true
    }
  },
  created () {
    this.fetchImage()
  },
  watch: {
    resourceId (v) {
      this.fetchImage()
      this.currentPage = 1
    }
  }

}
</script>

<style scoped>
.Receipts-Viewer--modal {
  z-index: 2001;
}
.image {
  height: 200px;
  width: 170px;
  margin: 20px 0px;
}
.img-content {
  width: auto;
  height: auto;
  max-width: 200px;
  max-height: auto;
  /*width:auto;
    height:auto;*/
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  /*background-position: 50% 50%;*/
  border: 1px solid #e9eef2;
}
/* .img-content, .img-content-pdf-horizontal:hover {
  border: 1px solid var(--gray);
  transition: border 0.5s ease-out;
} */
.image-fetching {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pdf--file {
  max-width: 200px;
  max-height: 200px;
}

/* @media screen and (max-width:576px ){
  .control-buttons {
    display:none;
  }
  .img-content {
    width:120px;
    height:auto;
  }
}*/
.img-content-pdf-horizontal {
  width: 50px;
  height: 75px !important;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: 50% 50%; */
  border: 1px solid #e9eef2;
}
.img-thumbnail-pdf-horizontal {
  padding: 0.25rem;
  background-color: var(--fill-main-background);
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}
</style>
<style lang="scss">
.control-buttons {
  display: flex;
}
</style>
